import React, { useEffect, useState } from "react";

const UploadDocPanel = ({ list, editData }) => {
  const [uploadedDocData, setUploadedDocData] = useState([]);

  useEffect(() => {
    // Retrieve existing data from local storage
    const storedData = localStorage.getItem('uploadedDocData');
    const existingData = storedData ? JSON.parse(storedData) : [];
    setUploadedDocData(existingData);
  }, []);



  return (
    <div id="license-panel">
      {uploadedDocData && uploadedDocData.length > 0 ? (
        uploadedDocData.map((data, index) => (
          <div id={"panel" + index} key={index} className="licence-list employment-panel-list" >

            <ul className="data">
              <li className="clearfix">
                <label>{data.docType.ducument_desc}</label>
              </li>
              {data.checkAccepted ? (
                <li className="clearfix">
                  <span className="value lic-no">Document not provided.</span>
                </li>
              ) : (
                // Use conditional rendering for the compressed image
                <li className="clearfix" key={data.docType.id}>
                  {/* Retrieve the compressed image URL from local storage */}
                  {data.docType.id && (
                    <>
                      {(() => {
                        const compressedImageUrlKey = `compressedImageURL_${data.docType.id}`;
                        const compressedImageUrl = localStorage.getItem(compressedImageUrlKey);

                        // Use the retrieved compressed image URL
                        return compressedImageUrl ? (
          <img
            src={compressedImageUrl}
            width="120px"
            height="76px"
          />
        ) : (
          <span className="value lic-no">Document not provided.</span>
        );
      })()}
                    </>
                  )}
                </li>
              )}
              <li className="clearfix edit-data">
                {/* Conditionally render the "Save" button */}
             
                  <button
                    style={{ border: "none" }}
                    className="edit employment-edit"
                    onClick={() => editData(index, data)} // Pass the updateData function to editData
                  >
                    Edit
                  </button>
              
              </li>
            </ul>
          </div>
        ))
      ) : (
        <img src="images/empty-data.png" alt="Empty data" />
      )}
    </div>
  );
};

export default UploadDocPanel;
